module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal custom-modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask modal-lg"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "width": "initial"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-info-circle"
  }), _vm._v(" Client #" + _vm._s(_vm.client.client_lookup_code) + " "), _c('small', [_vm._v("[" + _vm._s(_vm.client.id) + "]")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body pre-scrollable",
    style: ({
      'max-height': _vm.bodyHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "lead-detail"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 bg-dark lead-data"
  }, [_c('h4', [_vm._v("Details")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 fields-list-wrapper"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Account Name")]), _c('td', [_vm._v(_vm._s(_vm.client.account_name))])]), _c('tr'), _c('tr', [_c('th', [_vm._v("Client Lookup Code")]), _c('td', [_vm._v(_vm._s(_vm.client.client_lookup_code))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Client Id")]), _c('td', [_vm._v(_vm._s(_vm.client.client_id))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Format")]), _c('td', [_vm._v(_vm._s(_vm.client.format_option) + " "), (_vm.client.inactive_reason) ? _c('span', [_vm._v("(" + _vm._s(_vm.client.inactive_reason) + ")")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Source")]), _c('td', [_vm._v(_vm._s(_vm.client.account_source))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _c('td', [_vm._v(_vm._s(_vm.client.accountvalue_accountemail))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone")]), _c('td', [(_vm.client.accountvalue_phonecountrycode) ? _c('span', [_vm._v("(+" + _vm._s(_vm.client.accountvalue_phonecountrycode) + ")")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.client.accountvalue_number))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 bg-dark lead-data"
  }, [_c('h4', [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 fields-list-wrapper"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Street")]), _c('td', [_vm._v(_vm._s(_vm.client.accountvalue_address_street1))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Street 2")]), _c('td', [_vm._v(_vm._s(_vm.client.accountvalue_address_street2))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("City")]), _c('td', [_vm._v(_vm._s(_vm.client.accountvalue_address_city))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("County")]), _c('td', [_vm._v(_vm._s(_vm.client.accountvalue_address_county))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Zip or Postal Code")]), _c('td', [_vm._v(_vm._s(_vm.client.accountvalue_address_ziporpostalcode))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("State or Province Code")]), _c('td', [_vm._v(_vm._s(_vm.client.accountvalue_address_stateorprovincecode))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Country")]), _c('td', [_vm._v(_vm._s(_vm.client.accountvalue_address_countrycode))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 bg-dark lead-data"
  }, [_c('h4', [_vm._v("Branches")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 fields-list-wrapper"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', _vm._l((_vm.client.accountvalue_structure_branches), function(branch) {
    return _c('tr', [_c('td', [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(branch.code))]), _vm._v(" " + _vm._s(branch.description))])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 bg-dark lead-data"
  }, [_c('h4', [_vm._v("Policies")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 fields-list-wrapper"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Policy Number")]), _vm._v(" "), _c('th', [_vm._v("Policy Id")]), _vm._v(" "), _c('th', [_vm._v("Type Code")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Effective Date")]), _vm._v(" "), _c('th', [_vm._v("Expiration Date")]), _vm._v(" "), _c('th', [_vm._v("Billed Premiun")]), _vm._v(" "), _c('th', [_vm._v("Estimated Premium")]), _vm._v(" "), _c('th', [_vm._v("Annualized Premium")]), _vm._v(" "), _c('th', [_vm._v("Downloaded Premium")]), _vm._v(" "), _c('th', [_vm._v("Billed Commission")]), _vm._v(" "), _c('th', [_vm._v("Estimated Commission")]), _vm._v(" "), _c('th', [_vm._v("Annualized Commission")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.client.policies), function(policy) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(policy.policy_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(policy.policy_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(policy.policy_type_code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(policy.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(policy.effective_date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(policy.expiration_date)))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(policy.billed_premium))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(policy.estimated_premium))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(policy.annualized_premium))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(policy.downloaded_premium))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(policy.billed_premium))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(policy.estimated_commission))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(policy.annualized_commission))])])
  }), 0)])])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-537532e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/EpicClientModal.vue
// module id = 648
// module chunks = 0